import React from 'react';

export const FallbackMedicalIcon = (props) => {
  const {
    className = '',
    style = {},
    disabled = false,
    onClick,
    hideEclipse = false,
    viewBox = '0 0 60 60',
  } = props;

  return (
    <svg
      className={className}
      style={style}
      width="60"
      height="60"
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {!hideEclipse && <ellipse cx="30" cy="30" rx="30" ry="30" fill="#F5F5F5" />}
    </svg>
  );
};
